var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOverflow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 61.9 62.3",
    fill: "currentColor",
    width: "1em",
    height: "1em"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.1,
    cy: 8.1,
    r: 8.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 8.1,
    r: 8.1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.8,
    cy: 8.1,
    r: 8.1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.1,
    cy: 31.2,
    r: 8.1
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 31.2,
    r: 8.1
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.8,
    cy: 31.2,
    r: 8.1
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.1,
    cy: 54.2,
    r: 8.1
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 54.2,
    r: 8.1
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.8,
    cy: 54.2,
    r: 8.1
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2MS45IDYyLjMiIGZpbGw9ImN1cnJlbnRDb2xvciI+PGNpcmNsZSBjeD0iOC4xIiBjeT0iOC4xIiByPSI4LjEiLz48Y2lyY2xlIGN4PSIzMSIgY3k9IjguMSIgcj0iOC4xIi8+PGNpcmNsZSBjeD0iNTMuOCIgY3k9IjguMSIgcj0iOC4xIi8+PGNpcmNsZSBjeD0iOC4xIiBjeT0iMzEuMiIgcj0iOC4xIi8+PGNpcmNsZSBjeD0iMzEiIGN5PSIzMS4yIiByPSI4LjEiLz48Y2lyY2xlIGN4PSI1My44IiBjeT0iMzEuMiIgcj0iOC4xIi8+PGNpcmNsZSBjeD0iOC4xIiBjeT0iNTQuMiIgcj0iOC4xIi8+PGNpcmNsZSBjeD0iMzEiIGN5PSI1NC4yIiByPSI4LjEiLz48Y2lyY2xlIGN4PSI1My44IiBjeT0iNTQuMiIgcj0iOC4xIi8+PC9zdmc+Cg==";
export { SvgOverflow as ReactComponent };